import type { Country, Locale } from '@/types/regionTypes';

import * as M from '@/messages/myAccount';

export const getDataChangedMessage = (editedData: string | string[]) => {
  switch (editedData) {
    case 'phone':
      return M.YourPhoneHasBeenChanged;
    case 'email':
      return M.YourEmailHasBeenChanged;
    case 'password':
      return M.YourPasswordHasBeenChanged;
    case 'details':
      return M.YourDetailsHaveBeenChanged;
    case 'address':
      return M.YourAddressHaveBeenChanged;
    case 'addAddress':
      return M.YourAddressHaveBeenAdded;
    case 'deleteAddress':
      return M.YourAddressHaveBeenDeleted;
    default:
      return M.YourDetailsHaveBeenChanged;
  }
};

export const getFullName = (
  country: Country,
  locale: Locale,
  firstName?: string,
  lastName?: string,
) => {
  const fullName =
    country.code === 'JP' && (locale.slug === 'ja' || locale.slug === 'zh')
      ? `${lastName ?? ''} ${firstName ?? ''}`
      : `${firstName ?? ''} ${lastName ?? ''}`;

  return fullName.trim();
};
